export function createReentrancyGuard(): {
  active: () => boolean;
  run: <T>(fn: () => T) => T;
} {
  let depth = 0;
  return {
    active: () => depth > 0,
    run<T>(fn: () => T): T {
      depth++;
      try {
        return fn();
      } finally {
        depth--;
      }
    },
  };
}
